const STATUS_MAP = {
  1: {
    text: "Completed",
    className: "text-green-3 bg-emerald-100",
  },

  0: {
    text: "In Progress",
    className: "text-sky-700 bg-sky-100",
  },

  undefined: {
    text: "Not Completed",
    className: "text-gray-700 bg-gray-200",
  },
};

const StageStatusBadge = ({ status }) => {
  const currentStatus = STATUS_MAP[status] || STATUS_MAP.undefined;

  return (
    <span className={`${currentStatus.className} rounded-full px-2 py-1`}>
      {currentStatus.text}
    </span>
  );
};

export default StageStatusBadge;
